import { HttpClient } from "@angular/common/http";
import { TdspBaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class TdspContextualCategoryService extends TdspBaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  get resource_url(): string {
    return `${this.activeBaseUrl}/custom-contextual-categories/`;
  }

  getLanguages(params = {}) {
    let url = this.buildUrl(
      `${this.resource_url}contextual-languages`,
      "",
      params
    );
    return this.get(url);
  }
}
